module.exports = {
  getPaymentsQuery: getPaymentsQuery
};
var Parse = require("parse");
function getPaymentsQuery(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    methodArray = _ref.methodArray,
    typeArray = _ref.typeArray,
    stateArray = _ref.stateArray,
    postalPrefixes = _ref.postalPrefixes,
    signArray = _ref.signArray,
    businessIdArray = _ref.businessIdArray,
    user = _ref.user,
    id = _ref.id;
  var query = new Parse.Query("Payments");
  if (methodArray && methodArray.length > 0) query.containedIn("Method", methodArray);
  if (typeArray && typeArray.length > 0) query.containedIn("Type", typeArray);
  if (stateArray && stateArray.length > 0) query.containedIn("Action", stateArray);
  if (signArray && signArray.length == 1) {
    if (signArray[0] === "positive") query.greaterThan("Price", 0);else if (signArray[0] === "negative") query.lessThan("Price", 0);
  } else query.exists("Price");
  if (postalPrefixes && postalPrefixes.length > 0 || businessIdArray && businessIdArray.length > 0) {
    var jobQuery = new Parse.Query("Jobs");
    if (postalPrefixes && postalPrefixes.length > 0) {
      var pp = postalPrefixes.join("|");
      jobQuery.matches("PostalCode", new RegExp("^(".concat(pp, ")")));
    }
    if (businessIdArray && businessIdArray.length > 0) {
      var businesses = businessIdArray.map(function (businessId) {
        return Parse.Object.extend("Business").createWithoutData(businessId);
      });
      jobQuery.containedIn("Business", businesses);
    }
    query.matchesQuery("Job", jobQuery);
  }
  if (startDate) query.greaterThan("createdAt", startDate);
  if (endDate) query.lessThan("createdAt", endDate);
  if (id && id.length > 0) query.startsWith("ReceiptName", id);
  if (user) query.equalTo("User", user);
  return query;
}